"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Thead_1 = require("./Thead");
exports.default = Thead_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Table/components/Thead/index.js
// module id = 552
// module chunks = 8